export default __webpack_public_path__ + "static/media/download_appgallery.12446275.png";